import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import { getPriceLadder, getPriceLadderChart2 } from 'gqlQueries/priceLadder';
import { priceLadderAttributeLevelChart2Parser } from 'parser/priceLadderParser';
import { getPriceCurveChart2 } from 'gqlQueries/priceCurve';
const errorMessage: string = 'Something went wrong!';

function useFetchBarChart() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>(null);
    const [count, setCount] = useState(0);
    const variablesRef = useRef<any>({});
    const rawDataRef = useRef<any[]>([]);
    const { appConfig } = useContext(UserContext);
    const commonConfig = getConfig('commonConfig', appConfig);

    const [fetchBarChartData, { data: landscapeData, loading: landscapeDataLoading, error: landscapeDataError }] =
        useLazyQuery(getPriceCurveChart2, {
            onCompleted: onFetchComplete,
            onError: onFetchError,
        });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getIndexGraphData: getIncentiveGraphData } = payload;
            if (getIncentiveGraphData && 'values' in getIncentiveGraphData) {
                if (getIncentiveGraphData.values?.length === 0) throw 'No Data';
                const parsedChartData = priceLadderAttributeLevelChart2Parser(
                    getIncentiveGraphData?.values,
                    getIncentiveGraphData?.baseLineValue,
                );
                setData({ chartData: parsedChartData });
            }
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setData(null);
        setCount(0);
        rawDataRef.current = [];
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        count,
        data,
        fetchBarChartData: (variables: any) => {
            variablesRef.current = variables.variables;
            //only set data to null if function is being called outside/without infinite scroll
            //if offset is equal to default offset, it means request is coming without infinite scroll
            // if (commonConfig.offset === variables.variables?.offset) {
            //     setData(null);
            //     rawDataRef.current = [];
            //     setError(null);
            // }
            setData(null);
            setLoading(true);
            setError(null);
            fetchBarChartData(variables);
            // onFetchComplete(variables);
        },
    };
}

export { useFetchBarChart };
